import React from 'react';
import './App.css';
import Drum from './components/Drum'

function App() {
  return (
    <div className="App">
      <Drum />
    </div>
  );
}

export default App;
